import { Environment } from '@skyslope/auth-js';
import type { AppEnvironment } from '@skyslope/utils';

const prodEnv = {
  envName: 'prod' as AppEnvironment,
  REACT_APP_DS_API_URL: 'https://digisign3.skyslope.com/api',
  REACT_APP_TEMPLATES_URL: 'https://digisign3.skyslope.com/api',
  REACT_APP_TEMPLATE_UI_CLIENT_ID: '0oa4yvtikyN0RBDI34x6',
  REACT_APP_HEAP_APP_ID: '3954488189',
  REACT_APP_SENDER_UI_CLIENT_ID: '0oam9zo1eK0Td9fhm4x6',
  REACT_APP_AZURE_FNF_IDP: '0oaanuqiyrjdGz5g14x7',
  REACT_APP_CLIENT_ID_FOR_PRIME_AUTH_SERVER: 'S9WIdySIsIn3P7JhzCFp',
  REACT_APP_FORMS_URL: 'https://forms.skyslope.com/',
  REACT_APP_SIGNER_UI_URL: 'https://sign.skyslope.com/envelope',
  REACT_APP_PRIME_API_URL: 'https://api.skyslope.com/api',
  REACT_APP_PREFERENCES_URL: 'https://send.skyslope.com/preferences',
  REACT_APP_GOOGLE_TAG_MANAGER_ID: '8WAA4RAALtwpjBysEvBZig',
  SECURITY_TIMEOUT: 900,
  REACT_APP_ACCOUNT_API_URL: 'https://accounts.skyslope.com/api',
  LAUNCH_DARKLY_CLIENT_ID: '5dae1dcd45554708acda28fa',
  OKTA_AUTH_SERVER_ID: 'aus2ukovqrWcy6TUw4x6',
  OKTA_BASE_URL: 'https://id.skyslope.com',
  REACT_APP_BROKER_MANAGEMENT_URL: 'https://admin.skyslope.com/people',
  ACCOUNT_ROLES: {
    GROUP_ADMIN: '7a30ea74-a746-4f1e-89b1-04f77fe9d9e1',
    BROKER_ADMIN: 'd88de0bd-7eac-4b47-b81b-a403c0390af4',
  },
  PRIME_INTEGRATION_UI_CLIENT_ID: '0oama1gqxZ1rVnCCd4x6',
  OKTA_ENV: Environment.Prod,
  STANDALONE_LOGOUT_REDIRECT_URL: 'https://skyslope.com/digisign-login',
  STANDALONE_LOGIN_URL: 'https://skyslope.com/digisign-login',
  INTEGRATIONS_API_URL: 'https://integrations.skyslope.com/api',
};

type EnvironmentConfig = typeof prodEnv;

export const config: Record<AppEnvironment, EnvironmentConfig> = {
  // local: {
  //   LAUNCH_DARKLY_CLIENT_ID: '5dae1d82309d840897edaa57',
  //   OKTA_AUTH_SERVER_ID: 'aus15nfoj3xGfAiHp357',
  //   OKTA_BASE_URL: 'https://id-integ.skyslope.com',
  // },
  integ: {
    envName: 'integ',
    REACT_APP_DS_API_URL: 'https://integ-digisign3.skyslope.com/api',
    REACT_APP_TEMPLATES_URL: 'https://integ-digisign3.skyslope.com/api',
    // REACT_APP_TEMPLATES_URL: 'http://localhost:8085',
    REACT_APP_TEMPLATE_UI_CLIENT_ID: '0oa3ak4arrMBrfT2O357',
    REACT_APP_HEAP_APP_ID: '355210786',
    REACT_APP_SENDER_UI_CLIENT_ID: '0oa4tt1730gynqX0Q357',
    REACT_APP_AZURE_FNF_IDP: '0oaobqdubuAjI3B4E357',
    REACT_APP_CLIENT_ID_FOR_PRIME_AUTH_SERVER: 'ZZom7rwlQQBqvyYGvHyM',
    REACT_APP_FORMS_URL: 'https://integ-forms.skyslope.com/',
    REACT_APP_SIGNER_UI_URL: 'https://integ-sign.skyslope.com/envelope',
    REACT_APP_PRIME_API_URL: 'https://api-integ.skyslope.com/api',
    REACT_APP_PREFERENCES_URL: 'https://integ-send.skyslope.com/preferences',
    REACT_APP_GOOGLE_TAG_MANAGER_ID: 'AC2GoMnqdtM_fTnRg-Fg_g',
    SECURITY_TIMEOUT: 900,
    REACT_APP_ACCOUNT_API_URL: 'https://accounts-integ.skyslope.com/api',
    LAUNCH_DARKLY_CLIENT_ID: '5dae1d9b45554708acda28f4',
    OKTA_AUTH_SERVER_ID: 'aus15nfoj3xGfAiHp357',
    OKTA_BASE_URL: 'https://id-integ.skyslope.com',
    REACT_APP_BROKER_MANAGEMENT_URL: 'https://integ-admin.skyslope.com/people',
    ACCOUNT_ROLES: {
      GROUP_ADMIN: '7a30ea74-a746-4f1e-89b1-04f77fe9d9e1',
      BROKER_ADMIN: 'd88de0bd-7eac-4b47-b81b-a403c0390af4',
    },
    PRIME_INTEGRATION_UI_CLIENT_ID: '0oa4u6lv4tOIKGf8O357',
    OKTA_ENV: Environment.Integ,
    STANDALONE_LOGOUT_REDIRECT_URL: 'https://integ-send.skyslope.com',
    STANDALONE_LOGIN_URL: '', // Should not be set for lower environments; see `onAuthRequired` in oktaConfig.ts
    INTEGRATIONS_API_URL: 'https://integ-integrations.skyslope.com/api',
  },
  staging: {
    envName: 'staging',
    REACT_APP_DS_API_URL: 'https://staging-digisign3.skyslope.com/api',
    REACT_APP_TEMPLATES_URL: 'https://staging-digisign3.skyslope.com/api',
    REACT_APP_TEMPLATE_UI_CLIENT_ID: '0oaqkbm86fvmCmY6B0h7',
    REACT_APP_HEAP_APP_ID: '1691345378',
    REACT_APP_SENDER_UI_CLIENT_ID: '0oasvmf5tbnbrjguK0h7',
    REACT_APP_AZURE_FNF_IDP: '0oa1hcw4wfuS0bSTa0h8',
    REACT_APP_CLIENT_ID_FOR_PRIME_AUTH_SERVER: 'BvVJfA5l65ICbULHQeHf',
    REACT_APP_FORMS_URL: 'https://staging-forms.skyslope.com/',
    REACT_APP_SIGNER_UI_URL: 'https://staging-sign.skyslope.com/envelope',
    REACT_APP_PRIME_API_URL: 'https://api-staging.skyslope.com/api',
    REACT_APP_PREFERENCES_URL: 'https://staging-send.skyslope.com/preferences',
    REACT_APP_GOOGLE_TAG_MANAGER_ID: '9OVXeDhfb1ILj5G0lpxTtw',
    SECURITY_TIMEOUT: 900,
    REACT_APP_ACCOUNT_API_URL: 'https://accounts-staging.skyslope.com/api',
    LAUNCH_DARKLY_CLIENT_ID: '5dae1db245554708acda28f7',
    OKTA_AUTH_SERVER_ID: 'ausq0hw1h65nne9mH0h7',
    OKTA_BASE_URL: 'https://id-staging.skyslope.com',
    REACT_APP_BROKER_MANAGEMENT_URL: 'https://staging-admin.skyslope.com/people',
    ACCOUNT_ROLES: {
      GROUP_ADMIN: '7a30ea74-a746-4f1e-89b1-04f77fe9d9e1',
      BROKER_ADMIN: 'd88de0bd-7eac-4b47-b81b-a403c0390af4',
    },
    PRIME_INTEGRATION_UI_CLIENT_ID: '0oasvmbr6zMk4bkUF0h7',
    OKTA_ENV: Environment.Staging,
    STANDALONE_LOGOUT_REDIRECT_URL: 'https://staging-send.skyslope.com',
    STANDALONE_LOGIN_URL: '', // Should not be set for lower environments; see `onAuthRequired` in oktaConfig.ts
    INTEGRATIONS_API_URL: 'https://staging-integrations.skyslope.com/api',
  },
  prod: prodEnv,
};

// @ts-expect-error -- This code was written prior to enforcing lint rules
export const env = (config[window.DS3_ENV] ? window.DS3_ENV : 'integ') as AppEnvironment;
export const environmentConfig = config[env];
// @ts-expect-error -- This code was written prior to enforcing lint rules
window.DS3_CONFIG = environmentConfig;

export const API_URL = environmentConfig.REACT_APP_DS_API_URL;
export const TEMPLATES_URL = environmentConfig.REACT_APP_TEMPLATES_URL || API_URL;
export const templateUIClientId = environmentConfig.REACT_APP_TEMPLATE_UI_CLIENT_ID;
export const senderUIClientId = environmentConfig.REACT_APP_SENDER_UI_CLIENT_ID;
export const azureFNFIDP = environmentConfig.REACT_APP_AZURE_FNF_IDP;
export const primeAuthClientId = environmentConfig.REACT_APP_CLIENT_ID_FOR_PRIME_AUTH_SERVER;
export const formsUrl = environmentConfig.REACT_APP_FORMS_URL;
export const standaloneLogoutRedirectUrl = environmentConfig.STANDALONE_LOGOUT_REDIRECT_URL;
export const standaloneLoginUrl = environmentConfig.STANDALONE_LOGIN_URL;
export const signerUiUrl = environmentConfig.REACT_APP_SIGNER_UI_URL;
export const primeApiUrl = environmentConfig.REACT_APP_PRIME_API_URL;
export const preferencesUrl = environmentConfig.REACT_APP_PREFERENCES_URL;
export const timeoutInterval = environmentConfig.SECURITY_TIMEOUT;
export const GOOGLE_TAG_MANAGER_ID = environmentConfig.REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const accountApiUrl = environmentConfig.REACT_APP_ACCOUNT_API_URL;
export const { ACCOUNT_ROLES } = environmentConfig;
export const brokerManagementUrl = environmentConfig.REACT_APP_BROKER_MANAGEMENT_URL;
export const integrationUIClientId = environmentConfig.PRIME_INTEGRATION_UI_CLIENT_ID;
export const oktaEnv = environmentConfig.OKTA_ENV;
export const oktaDS3Iss = environmentConfig.OKTA_BASE_URL + '/oauth2/' + environmentConfig.OKTA_AUTH_SERVER_ID;
export const integrationsApiUrl = environmentConfig.INTEGRATIONS_API_URL;
